import moment from 'moment';
import React from 'react';
import { formatDate } from '../../utils';
import InfoTooltip from './InfoTooltip';

const minDate = (billingConfig) => billingConfig && billingConfig.ledger_lock && moment(billingConfig.ledger_lock).add(1, 'day').toDate();

export const ledgerLockCalendarParams = (billingConfig) => (minDate(billingConfig) ? { minDate: minDate(billingConfig) } : {});

export const LedgerLockDateLabel = ({ billingConfig }) => (
  <React.Fragment>
    Date
    {minDate(billingConfig) && (
      <InfoTooltip
        placement='right'
        name='info-circle'
        preNbsp
      >
        {`Billing dates prior to ${formatDate(minDate(billingConfig))} have been locked.`}
      </InfoTooltip>
    )}
  </React.Fragment>
);
